const Welcome = () => import('~/pages/welcome').then(m => m.default || m)
const Certificate = () => import('~/pages/certificate').then(m => m.default || m)
const Login = () => import('~/pages/auth/login').then(m => m.default || m)
const Register = () => import('~/pages/auth/register').then(m => m.default || m)
const PasswordEmail = () => import('~/pages/auth/password/email').then(m => m.default || m)
const PasswordReset = () => import('~/pages/auth/password/reset').then(m => m.default || m)
const NotFound = () => import('~/pages/errors/404').then(m => m.default || m)

const Home = () => import('~/pages/home').then(m => m.default || m)
const Settings = () => import('~/pages/settings/index').then(m => m.default || m)
const SettingsProfile = () => import('~/pages/settings/profile').then(m => m.default || m)
const SettingsPassword = () => import('~/pages/settings/password').then(m => m.default || m)

const Users = () => import('~/pages/users/index').then(m => m.default || m)
const UsersNew = () => import('~/pages/users/form').then(m => m.default || m)
const UsersEdit = () => import('~/pages/users/form').then(m => m.default || m)

const Acts = () => import('~/pages/events/index').then(m => m.default || m)
const ActsNew = () => import('~/pages/events/form').then(m => m.default || m)
const ActsEdit = () => import('~/pages/events/form').then(m => m.default || m)

const People = () => import('~/pages/people/index').then(m => m.default || m)
const PeopleNew = () => import('~/pages/people/form').then(m => m.default || m)
const PeopleEdit = () => import('~/pages/people/form').then(m => m.default || m)

const Health = () => import('~/pages/health').then(m => m.default || m)

const Help = () => import('~/pages/help').then(m => m.default || m)

export default [
  { path: '/', name: 'welcome', component: Welcome },
  { path: '/certificate/:hash', name: 'certificateshow', component: Certificate },

  { path: '/login', name: 'login', component: Login },
  { path: '/register', name: 'register', component: Register },
  { path: '/password/reset', name: 'password.request', component: PasswordEmail },
  { path: '/password/reset/:token', name: 'password.reset', component: PasswordReset },

  { path: '/home', name: 'home', component: Home },
  { path: '/settings',
    component: Settings,
    children: [
      { path: '', redirect: { name: 'settings.profile' } },
      { path: 'profile', name: 'settings.profile', component: SettingsProfile },
      { path: 'password', name: 'settings.password', component: SettingsPassword }
    ] },

  { path: '/users', name: 'users', component: Users },
  { path: '/users/new', name: 'usersnew', component: UsersNew },
  { path: '/users/:id', name: 'usersedit', component: UsersEdit },

  { path: '/events', name: 'events', component: Acts },

  { path: '/events/new', name: 'eventsnew', component: ActsNew },
  { path: '/events/:id', name: 'eventsedit', component: ActsEdit },
  
  { path: '/people', name: 'people', component: People },
  { path: '/people/new', name: 'peoplenew', component: PeopleNew },
  { path: '/people/:id', name: 'peopleedit', component: PeopleEdit },

  { path: '/health', name: 'health', component: Health },

  { path: '/help', name: 'help', component: Help },

  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./resources/assets/js/router/routes.js